export interface IMultipleRealmsState {
  isLoading: boolean;
  disabledRegisterButton: boolean;
  userToken?: string;
}

export const defaultState: IMultipleRealmsState = {
  isLoading: false,
  disabledRegisterButton: false,
  userToken: null,
};
